import { useState } from "react";
import { Button, Card, CardBody, Col, Collapse, Row } from "reactstrap";
import { HorizontalAccordionTitle, ToggleWidthCollapse } from "../../../constants";
import { HorizontalAccordionSubTitle } from "../../../data/uiKits/Accordion";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const HorizontalAccordion = () => {
  const [open, setOpen] = useState(false);

  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={HorizontalAccordionTitle} span={HorizontalAccordionSubTitle} />
        <CardBody>
          <div className="common-flex">
            <Button color="secondary" onClick={() => setOpen(!open)}>{ToggleWidthCollapse}</Button>
          </div>
          <Row className="custom-Horizontal-accordion">
            <Col sm="5">
              <Collapse isOpen={open} className={`mt-3`} horizontal>
                <div className="bg-light-secondary mb-0">
                  <div className="p-3">{"The collapse plugin also supports horizontal collapsing.Add the.collapse - horizontal modifier class to transition the width instead of height and set a width on the immediate child element.Feel free to write your own custom Sass, use inline styles, or use our width utilities."}</div>
                </div>
              </Collapse>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};
export default HorizontalAccordion;
